module.exports = __webpack_public_path__ + "static/img/M93K-PF_A.3b87477.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/M93K-PF_A.jpg
// module id = LCIi
// module chunks = 0